import { useRouter } from 'next/router';

import { useSignOut } from 'Utilities/hooks/useSignOut';
import useUser from 'Utilities/hooks/useUser';
import { useVehicleListButtonConfigWithUnauthedFallback } from 'Utilities/hooks/vehicleList/useVehicleListButtonConfig';

import {
	generateSiteNavigationHandlers,
	generateSiteNavigationPermissions,
} from '../PageComposerSiteNavigation.helpers';

import { useActiveItemId } from './useActiveItemId';
import { useNavigationState } from './useNavigationState';

export const usePageComposerSiteNavigation = () => {
	const userConfig = useUser();
	const router = useRouter();
	const activeItemId = useActiveItemId();
	const { hasBottomBorder, isHidden, isSticky, isTransparent } = useNavigationState();
	const { onSignOut: onSignoutHandler } = useSignOut();
	const marketplaceButton = useVehicleListButtonConfigWithUnauthedFallback();

	const onSignOut = (): void => {
		void onSignoutHandler();
	};

	const user = 'loggedOut' in userConfig ? undefined : userConfig;
	const permissions = generateSiteNavigationPermissions(user);
	const handlers = generateSiteNavigationHandlers({ marketplaceButton, onSignOut, router, user });

	return { activeItemId, handlers, hasBottomBorder, isHidden, isSticky, isTransparent, permissions };
};
